import { style } from "typestyle";
import { colors } from "styles/styles";

export const container = style({
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  height: "2.5rem",
  cursor: "pointer",
  borderRadius: "40px",
  backgroundColor: colors.hooplaWhite,
  color: colors.grey_10,
  border: `2px solid ${colors.hooplaBorderColor}`
});

export const active = style({
  borderColor: colors.hooplaBlue
});

export const whiteSquare = style({
  borderRadius: "2.3rem",
  width: "2.3rem",
  height: "2.3rem",
  backgroundColor: colors.hooplaBlue,
  marginLeft: "2.3rem"
});

export const greySquare = style({
  borderRadius: "2.3rem",
  width: "2.3rem",
  height: "2.3rem",
  backgroundColor: colors.hooplaBorderColor,
  marginRight: "2.3rem"
});
